module.exports = __webpack_public_path__ + "img/lustre.f3ef03ec.png";